import { render, staticRenderFns } from "./BrigadeForkliftTruckField.vue?vue&type=template&id=46b4d6eb&"
import script from "./BrigadeForkliftTruckField.vue?vue&type=script&lang=js&"
export * from "./BrigadeForkliftTruckField.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeForkliftTruckField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QField,QBtn,QTooltip}, component.options.components || {})
